import { render, staticRenderFns } from "./TradeBook.vue?vue&type=template&id=76c0c9d6"
import script from "./TradeBook.vue?vue&type=script&lang=js"
export * from "./TradeBook.vue?vue&type=script&lang=js"
import style0 from "./TradeBook.vue?vue&type=style&index=0&id=76c0c9d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports